import { AppError } from './app-error';

export class PreconditionError extends AppError {

}